import React from 'react';
import SidebarProfile from './SideBarProfile';
import EditPicture from '../../components/user-profile/edit-user-logo';
import TopSection from '../../components/TopSection';

export default function UserProfile(props) {
  return (
    <>
      <TopSection heading="Profile image" />
      <div className="main_container about-us about-top">
        <div className="container">
          <EditPicture
            ui="/profile"
            epr="/profile"
            edpr="profile-edit-user"
            epic="/main-edit-user-profile-picture"
            elog="/main-edit-user-company-logo"
          >
            <SidebarProfile />
          </EditPicture>
        </div>
      </div>
    </>
  );
}
